import { DIAGNOSTICS_EVIDENCE_COPY } from "./DiagnosticsTargetPicker.logic";
import type { DiagnosticsEvidenceClass } from "./DiagnosticsTargetPicker.logic";

/**
 * Every target panel opens with this. The three target kinds offer wildly
 * different evidence, and without saying so an empty Processes section on a
 * desktop device reads as "no processes running" rather than "Forge cannot see
 * that from here" — which is the difference between a diagnosis and a guess.
 */
export function DiagnosticsEvidenceNotice({
  evidence,
}: {
  readonly evidence: DiagnosticsEvidenceClass;
}) {
  const copy = DIAGNOSTICS_EVIDENCE_COPY[evidence];
  return (
    <p className="text-xs leading-relaxed text-muted-foreground">
      <span className="font-medium text-foreground">{copy.label}.</span> {copy.description}
    </p>
  );
}
